import { withStyles } from "@material-ui/core";
import Box from "@material-ui/core/Box";
import { useRootSelector } from "screens/Root/hooks/useAppSelector";
import React from "react";
import { useDispatch } from "react-redux";
import { setResizingActive } from "../../slices/rootSlice";
const ResizerContainer = withStyles({
    root: {
        width: 1,
        borderLeft: "2px solid black",
        opacity: "0.3",
        flexDirection: "row",
        cursor: "col-resize",
        zIndex: 500,
        marginLeft: "5px",
        height: "100%",
        "&:hover": {
            opacity: "0.5",
        },
    },
})(Box);
const Resizer = ({ dockedActive }) => {
    const dispatch = useDispatch();
    const mouseDown = () => {
        dispatch(setResizingActive(true));
    };
    const { appSettings, activeDockedTabKey, tabs, rightPanelExpanded } = useRootSelector();
    const activeDockedTabMenuId = activeDockedTabKey &&
        tabs[activeDockedTabKey] &&
        tabs[activeDockedTabKey].menuId;
    const showResizer = dockedActive &&
        activeDockedTabMenuId &&
        appSettings.StaticData.MenuItems[activeDockedTabMenuId].DockedSizable;
    return showResizer && rightPanelExpanded ? (<ResizerContainer onMouseDown={mouseDown}>
      <div className="resizer-backdrop" style={{ position: "fixed" }}></div>
    </ResizerContainer>) : null;
};
export default Resizer;
